import React, { memo } from 'react';
export function About() {
  return <section id="about" className="py-20 sm:py-24 lg:py-32 bg-white" data-id="element-1">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-2">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-center" data-id="element-3">
          {/* Image */}
          <div className="order-2 lg:order-1" data-id="element-4">
            <img src="https://images.unsplash.com/photo-1519741497674-611481863552?w=800&q=80" alt="Gardendale Venue outdoor ceremony space" className="w-full h-[500px] object-cover" data-id="element-5" />
          </div>

          {/* Content */}
          <div className="order-1 lg:order-2" data-id="element-6">
            <h2 className="text-4xl sm:text-5xl lg:text-6xl font-serif font-bold text-black mb-6" data-id="element-7">
              Welcome to Gardendale Venue
            </h2>
            <div className="w-16 h-px bg-gray-400 mb-8" data-id="element-8"></div>
            <p className="text-gray-600 text-base leading-relaxed mb-6" data-id="element-9">
              Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do
              eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut
              enim ad minim veniam, quis nostrud exercitation ullamco laboris
              nisi ut aliquip ex ea commodo consequat.
            </p>
            <p className="text-gray-600 text-base leading-relaxed mb-8" data-id="element-10">
              Duis aute irure dolor in reprehenderit in voluptate velit esse
              cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat
              cupidatat non proident, sunt in culpa qui officia deserunt mollit
              anim id est laborum.
            </p>
            <a href="#venue" className="inline-block border-2 border-black text-black px-8 py-3 text-sm tracking-widest hover:bg-black hover:text-white transition-colors" data-id="element-11">
              EXPLORE THE VENUE
            </a>
          </div>
        </div>
      </div>
    </section>;
}